import gql from 'graphql-tag'
import { COURSE_FIELDS, USER_FIELDS } from './fragments'

export const CREATE_ATTESTED_COURSE_COMPLETION_MUTATION = gql`
    mutation createAttestedCourseCompletion(
        $courseId: ID!
        $projectId: ID!
        $userId: ID!
        $completedAt: DateTime
    ) {
        createAttestedCourseCompletion(
            input: {
                courseId: $courseId
                projectId: $projectId
                userId: $userId
                completedAt: $completedAt
            }
        ) {
            attestedCourseCompletion {
                canDelete
                completedAt
                createdAt
                expiresAt
                id
                updatedAt
                attestingUser {
                    ...UserFields
                }
                course {
                    ...CourseFields
                }
            }
        }
    }
    ${COURSE_FIELDS}
    ${USER_FIELDS}
`

export const DELETE_COURSE_COMPLETION_MUTATION = gql`
    mutation deleteCourseCompletion($completionId: ID!) {
        deleteCourseCompletion(input: { completionId: $completionId }) {
            __typename
        }
    }
`

export const CREATE_SELF_ATTESTED_COMPLETION_MUTATION = gql`
    mutation createSelfAttestedCourseCompletion(
        $courseId: ID!
        $projectId: ID!
        $completedAt: DateTime
    ) {
        createSelfAttestedCourseCompletion(
            input: { courseId: $courseId, projectId: $projectId, completedAt: $completedAt }
        ) {
            selfAttestedCourseCompletion {
                canDelete
                completedAt
                createdAt
                expiresAt
                id
                updatedAt
                course {
                    ...CourseFields
                }
            }
        }
    }
    ${COURSE_FIELDS}
`
